import { render, staticRenderFns } from "./addRank.vue?vue&type=template&id=39b2a408&scoped=true&"
import script from "./addRank.vue?vue&type=script&lang=js&"
export * from "./addRank.vue?vue&type=script&lang=js&"
import style0 from "./addRank.vue?vue&type=style&index=0&id=39b2a408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2a408",
  null
  
)

export default component.exports